import { Product } from './Product';

export class MoneyGift extends Product {
  constructor(params: MoneyGift = {} as MoneyGift) {
    super(params);
  }
}
